import { TransferNotesModal } from "../modals/TransferNotesModal";

export function TransferMultiModal({
  notes,
  shouldShowTransferModal,
  setShouldShowTransferModal,
  refetch,
  bypassContext,
}) {
  return (
    <TransferNotesModal
      notes={notes}
      shouldShowTransferModal={shouldShowTransferModal}
      setShouldShowTransferModal={setShouldShowTransferModal}
      refetch={refetch}
      bypassContext={bypassContext}
    />
  );
}
